import { Autocomplete, CircularProgress, InputAdornment, TextField, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getAllStaff } from "store/lookup";

export default function StaffSearch({
  onSelect = () => {},
  label = 'Select Teacher',
  size = 'small',
  value= null,
  disabled = false,
  error = false,
  helperText = '',
}) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { academicYear, campus } = useSelector(state => state.session);
  const staff  = useSelector(state => state.lookup.allStaff.rows)
  const [activeOnly, setActiveOnly] = useState(true)

  useEffect(() => {
    staff || dispatch(getAllStaff({ limit: 1000 }))
  }, [academicYear.id, campus?.id]);

  const selectStaff = (event, value) => {
    onSelect(value);
  };
  const loading = !staff
  const filteredStaff = (staff ?? []).filter(s => s.isActive === activeOnly)

  return (
    <Autocomplete
      fullWidth
      disablePortal
      size={size}
      value={value}
      disabled={disabled}
      loading={loading}
      options={filteredStaff}
      onChange={selectStaff}
      getOptionLabel={option => {
        if (option?.person?.lastName && option?.person?.firstName) {
          return `${option.person.lastName}, ${option.person.firstName}`
        }
        const staffMember = (staff ?? []).find(
          staff => staff?.schoolEnrollmentId === +option || staff?.personId === +option
        )
        return staffMember?.person
          ? `${staffMember.person.lastName}, ${staffMember.person.firstName}`
          : ''
      }}
      renderInput={params => (
        <TextField
          {...params}
          fullWidth
          label={t(label)}
          disabled={disabled}
          error={error}
          helperText={helperText}
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <InputAdornment position="start">
                {/* Switch design — uncomment to use instead of pill
                <Tooltip title={activeOnly ? t('Active') : t('Inactive')}>
                  <Switch
                    size="small"
                    checked={activeOnly}
                    onChange={e => { setActiveOnly(e.target.checked); onSelect(null) }}
                    onClick={e => e.stopPropagation()}
                  />
                </Tooltip>
                */}
                <ToggleButtonGroup
                  value={activeOnly}
                  exclusive
                  size="small"
                  onChange={(_, val) => { if (val !== null) { setActiveOnly(val); onSelect(null) } }}
                  onClick={e => e.stopPropagation()}
                  sx={{ mr: 0.5, '& .MuiToggleButton-root': { py: 0.25, px: 1, fontSize: 10, border: 'none', borderRadius: '12px !important' } }}
                >
                  <ToggleButton value={true} color="success" sx={{ '&:not(.Mui-selected)': { color: 'text.secondary' } }}>{t('Active')}</ToggleButton>
                  <ToggleButton value={false} color="error" sx={{ '&:not(.Mui-selected)': { color: 'text.secondary' } }}>{t('Inactive')}</ToggleButton>
                </ToggleButtonGroup>
              </InputAdornment>
            ),
            endAdornment: (
              <>
                {loading && <CircularProgress size={16} sx={{ mr: 1 }} />}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
}
